import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientLocationDataModel } from '../../models/clients/client-location-data.model';

export interface LettersDeliveryOptionsDialogData {
  locations: ClientLocationDataModel[];
  currentLocationId: string;
}

@Component({
  standalone: false,
  selector: 'app-letters-delivery-options-dialog',
  templateUrl: './letters-delivery-options-dialog.component.html',
  styleUrls: ['./letters-delivery-options-dialog.component.scss']
})
export class LettersDeliveryOptionsDialogComponent implements OnInit {
  locations: ClientLocationDataModel[] = [];
  // Source location whose EmailReturnAddress is used as the "Letters Email From:" override.
  selectedLocationId: string = '';

  constructor(
    private dialogRef: MatDialogRef<LettersDeliveryOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: LettersDeliveryOptionsDialogData
  ) { }

  ngOnInit(): void {
    this.locations = this.data?.locations ?? [];
    this.selectedLocationId = this.data?.currentLocationId ?? '';
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    // Return the chosen source location id (empty => no override).
    this.dialogRef.close(this.selectedLocationId);
  }
}
